export function tCConfidentialityAgreementCP326() {
return [   // Release 2026-04-02 11:36:22
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 48.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 38.16,
   left: 167.455,
   width: 363.840,
   height: 9.96
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 149.237,
   left: 216.001,
   width: 324.764,
   height: 14.800
}
,
{
   page: 0,
   name: "Transaction Coordinator Fullname", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 174.873,
   left: 216.001,
   width: 324.764,
   height: 14.800
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 202.71,
   left: 216.001,
   width: 93.054,
   height: 12.836
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 739.08,
   left: 86.52,
   width: 273.60,
   height: 9.96
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 38.16,
   left: 166.8,
   width: 363.84,
   height: 9.96
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 739.08,
   left: 86.52,
   width: 273.60,
   height: 9.96
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 38.16,
   left: 166.8,
   width: 363.84,
   height: 9.96
}
,
{
   page: 2,
   name: "Signature Transaction Coordinator", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 586.487,
   left: 72.0,
   width: 216.24,
   height: 12.578
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 739.08,
   left: 86.52,
   width: 273.60,
   height: 9.96
}
] }
